import { contactUsMenu, FAQMenu } from "./menuItemsUser";

export const tpaPrimaryMenu = () => [
  {
    to: "/Claims",
    text: "Claims",
    description: "Manage claims",
    icon: "folders",
    subLinks: [
      {
        to: "/file-claim",
        text: "File a Claim"
      }
    ]
  },
  contactUsMenu,
  FAQMenu
];
